// extracted by mini-css-extract-plugin
export default {"titleContainer":"CurriculumTab_titleContainer__c5-xg","title":"CurriculumTab_title__xzxxo","sectionListContainer":"CurriculumTab_sectionListContainer__NU4KG"};